import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'
import moment from 'moment'
import Loading from 'bisu-react-loading'

import FormContainer from './form-container'
import { fetchNotePayment } from './actions'

const NotePaymentsShow  = ({ __item, params, onSearchForm }) => {
  const noteID = Number(params.id)
  if (__item.get('id') !== noteID) {
    return <Loading />
  }

  return (
    <FormContainer noteID={noteID} onSearchForm={onSearchForm} isShow />
  )
}

NotePaymentsShow.onEnter = (store) => (nextState) => {
  const noteID = Number(nextState.params.id)
  store.dispatch(fetchNotePayment(noteID))
    .then((res) => {
      if (res && !res.error) {
        store.dispatch(actions.change('notePaymentState', fromJS(res.payload || {}).set('paydate', moment(res.payload.paydate))))
      }
    })
}

NotePaymentsShow.propType = {
  __item: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __item: state.notePaymentState
  }
}

export default connect(mapStateToProps)(NotePaymentsShow)



// WEBPACK FOOTER //
// ./src/containers/NotePayments/show.js